module.exports = __webpack_public_path__ + "static/media/star_icon.cc7c1115.svg";